import type { LocalZoneRect } from "./types";

/** Compute play-area zones for 2–4 players on a shared canvas. */
export function computeLocalZones(cw: number, ch: number, playerCount: 2 | 3 | 4): LocalZoneRect[] {
    const zones: LocalZoneRect[] = [];
    if (playerCount === 2) {
        const half = cw / 2;
        zones.push(rect(0, 0, half, ch));
        zones.push(rect(half, 0, half, ch));
    } else if (playerCount === 3) {
        const third = cw / 3;
        zones.push(rect(0, 0, third, ch));
        zones.push(rect(third, 0, third, ch));
        zones.push(rect(third * 2, 0, third, ch));
    } else {
        const halfW = cw / 2;
        const halfH = ch / 2;
        zones.push(rect(0, 0, halfW, halfH));
        zones.push(rect(halfW, 0, halfW, halfH));
        zones.push(rect(0, halfH, halfW, halfH));
        zones.push(rect(halfW, halfH, halfW, halfH));
    }
    return zones;
}

function rect(x: number, y: number, w: number, h: number): LocalZoneRect {
    return { x, y, w, h, cx: x + w / 2, cy: y + h / 2 };
}

export function pointInZone(px: number, py: number, z: LocalZoneRect): boolean {
    return px >= z.x && px < z.x + z.w && py >= z.y && py < z.y + z.h;
}

export function zoneIndexAt(px: number, py: number, zones: LocalZoneRect[]): number {
    for (let i = 0; i < zones.length; i++) {
        if (pointInZone(px, py, zones[i]!)) return i;
    }
    return -1;
}

export function clampToZone(x: number, y: number, z: LocalZoneRect, inset: number): { x: number; y: number } {
    const minX = z.x + inset;
    const maxX = z.x + z.w - inset;
    const minY = z.y + inset;
    const maxY = z.y + z.h - inset;
    return {
        x: Math.max(minX, Math.min(maxX, x)),
        y: Math.max(minY, Math.min(maxY, y)),
    };
}
